module.exports = __webpack_public_path__ + "img/flag_it.e3295960.svg";